import { createWidgetCoordinateBridge } from "../utils/coordinateBridge";
export class ForkRuntimeAdapter {
    // L4: getChartScale removed (was dead — 0 callers; the main chart scale
    // comes from ChartScaleAdapter). This adapter owns pane snapshots (via
    // engine instance) + coordinate bridge only.
    buildPaneSnapshots(options) {
        return []; // Fork snapshots come from the engine instance directly
    }
    createCoordinateBridge(options) {
        const { paneSnapshots, visibleRange, plotData } = options;
        return createWidgetCoordinateBridge({
            paneSnapshots,
            visibleRange,
            plotData,
            engineRuntime: "fork",
        });
    }
}
